import React from 'react';
import {Link} from "gatsby"
import Layout from "../components/layout"
import CirclePath from "../components/circlePath"
import {graphql} from "gatsby"
import "./publicaciones02.scss"

const Publicaciones = ({
    data:{ allStrapiDocuments:{edges:documentos} }
}) => {

var proyecto = [];
var colaboracion = [];
var entrevista = [];
var ensayo = [];
var clase = [];

//// console.log(documentos);
documentos.map((e,i)=>{
    var current = e.node;
    //// console.log(current.categoria)

    switch(current.categoria){
        case "proyecto":
            proyecto.push(current)
        break
        case "colaboracion":
            colaboracion.push(current);
        break
        case "entrevista":
            entrevista.push(current);
        break
        case "ensayo":
            ensayo.push(current);
        break
        case "clase":
            clase.push(current);
        break
        default:
          // console.log("error");
  
      }

})


function obtenerLink(publicacion){
    console.log(publicacion)
    if(publicacion.archivo) return publicacion.archivo.url
    else return publicacion.link
}


//// console.log(proyecto,colaboracion,entrevista,ensayo)
    
    return (
        <Layout>
            
            <CirclePath text="• Publicaciones ▪ " textColor="#ffffff" />

            
            <div className="publicaciones">

                <div className="ensayosWrapper section">
                    <div className="ensayosTitulo">
                        <h1 className="title has-text-white">Ensayos y Papers:</h1>
                    </div>
                    {
                        ensayo.map((e,i)=>{
                            // console.log(e);
                            return(
                                <div>
                                    <div className="publicacion section has-text-white">
                                        <h1>{e.titulo}</h1>
                                        <h2>{e.descripcion}</h2>
                                        <div className="level">
                                            <div className="level-left">
                                                <div className="level-item">
                                                    <h2>{e.autor}</h2>
                                                </div>
                                            </div>
                                            <div className="level-right">
                                                <div className="level-item">
                                                    <a className="has-text-white" href={obtenerLink(e)} target="_blank">Link al PDF</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="divider"></div>
                                </div>
                            )
                        })
                    }

                    

                </div>

                <div className="proyectosWrapper section ">
                    <div className="proyectosTitulo">
                        <h1 className="title has-text-white">Proyectos:</h1>
                    </div>
                    {
                        proyecto.map((e,i)=>{
                            // console.log(e);
                            return(
                                <div>
                                    <div className="publicacion section has-text-white">
                                        <h1>{e.titulo}</h1>
                                        <h2>{e.descripcion}</h2>
                                        <div className="level">
                                            <div className="level-left">
                                                <div className="level-item">
                                                    
                                                </div>
                                            </div>
                                            <div className="level-right">
                                                <div className="level-item">
                                                    <a className="has-text-white" href={obtenerLink(e)}  target="_blank">Link al PDF</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="divider"></div>
                                </div>
                            )
                        })
                    }

                    

                </div>

                <div className="clasesWrapper section">
                    <div className="clasesTitulo">
                        <h1 className="title has-text-white">Clases:</h1>
                    </div>
                    {
                        clase.map((e,i)=>{
                            // console.log(e);
                            return(
                                <div>
                                    <div className="publicacion section has-text-white">
                                        <h1>{e.titulo}</h1>
                                        <h2>{e.descripcion}</h2>
                                        <div className="level">
                                            <div className="level-left">
                                                <div className="level-item">
                                                    <h2>{e.autor}</h2>
                                                </div>
                                            </div>
                                            <div className="level-right">
                                                <div className="level-item">
                                                    <a className="has-text-white" href={obtenerLink(e)} target="_blank">Link al video</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="divider"></div>
                                </div>
                            )
                        })
                    }

                    

                </div>

                <div className="colaboracionesWrapper section">
                    <div className="colaboracionesTitulo">
                        <h1 className="title has-text-white">Colaboraciones:</h1>
                    </div>
                    {
                        colaboracion.map((e,i)=>{
                            // console.log(e);
                            return(
                                <div>
                                    <div className="publicacion section has-text-white">
                                        <h1>{e.titulo}</h1>
                                        <h2>{e.descripcion}</h2>
                                        <div className="level">
                                            <div className="level-left">
                                                <div className="level-item">
                                                    <h2>{e.autor}</h2>
                                                </div>
                                            </div>
                                            <div className="level-right">
                                                <div className="level-item">
                                                    <a className="has-text-white" href={obtenerLink(e)} target="_blank">Link al PDF</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="divider"></div>
                                </div>
                            )
                        })
                    }

                    

                </div>

                <div className="entrevistasWrapper section">
                    <div className="entrevistasTitulo">
                        <h1 className="title has-text-white">Entrevistas y Prensa:</h1>
                    </div>
                    {
                        entrevista.map((e,i)=>{
                            // console.log(e);
                            return(
                                <div>
                                    <div className="publicacion section has-text-white">
                                        <h1>{e.titulo}</h1>
                                        <h2>{e.descripcion}</h2>
                                        <div className="level">
                                            <div className="level-left">
                                                <div className="level-item">
                                                    <h2>{e.autor}</h2>
                                                </div>
                                            </div>
                                            <div className="level-right">
                                                <div className="level-item">
                                                    <a className="has-text-white" href={obtenerLink(e)} target="_blank">Link</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="divider"></div>
                                </div>
                            )
                        })
                    }

                    

                </div>

            </div>
  
        </Layout>
    );
}



export const query = graphql`
  {
    allStrapiDocuments {
      edges {
        node {
          titulo
          descripcion
          categoria
          link
          autor
          archivo {
            id
            url
          }
        }
      }
    }
  }
`

export default Publicaciones;
